var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoaded)?_c('div',{staticClass:"share-container"},[(!_vm.$route.name.includes('VisitorRetention') && !_vm.$route.name==='ShareA/B Result')?_c('Header'):_vm._e(),_vm._v(" "),(_vm.isLoaded)?_c('div',[_c('div',{staticClass:"share-section"},[_vm._t("default")],2)]):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c8d8023","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/shareLinkAuth.vue
// module id = null
// module chunks = 